/* tslint:disable */
/* eslint-disable */
/**
 * Y-sports-Core API
 * API for managing Y-sports related stuff
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlayerUpdateRequest
 */
export interface PlayerUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof PlayerUpdateRequest
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerUpdateRequest
     */
    secondName?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerUpdateRequest
     */
    lastName?: string;
    /**
     * Birth year
     * @type {number}
     * @memberof PlayerUpdateRequest
     */
    birthDate?: number;
    /**
     * 
     * @type {string}
     * @memberof PlayerUpdateRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerUpdateRequest
     */
    phoneNumber?: string;
    /**
     * Jersey/player number
     * @type {number}
     * @memberof PlayerUpdateRequest
     */
    playerNumber?: number;
}

/**
 * Check if a given object implements the PlayerUpdateRequest interface.
 */
export function instanceOfPlayerUpdateRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PlayerUpdateRequestFromJSON(json: any): PlayerUpdateRequest {
    return PlayerUpdateRequestFromJSONTyped(json, false);
}

export function PlayerUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlayerUpdateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'secondName': !exists(json, 'secondName') ? undefined : json['secondName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'birthDate': !exists(json, 'birthDate') ? undefined : json['birthDate'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'playerNumber': !exists(json, 'playerNumber') ? undefined : json['playerNumber'],
    };
}

export function PlayerUpdateRequestToJSON(value?: PlayerUpdateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'firstName': value.firstName,
        'secondName': value.secondName,
        'lastName': value.lastName,
        'birthDate': value.birthDate,
        'email': value.email,
        'phoneNumber': value.phoneNumber,
        'playerNumber': value.playerNumber,
    };
}

